module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyList'
      }),
      expression: "{name:'ISaiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我报名的比赛",
      "label": "以备案单位为主体发起报名参加的啦啦操比赛管理证书下载"
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaIndex'
      }),
      expression: "{name:'ChaIndex'}"
    }],
    attrs: {
      "is-link": "",
      "title": "教练员裁判员优秀证书下载",
      "label": "教练员裁判员优秀证书下载"
    }
  }), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "家长认证",
      "label": "上传身份证明信息，完成后自动关联子女运动员信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("管理")])]
      },
      proxy: true
    }], null, false, 589936917)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{name:'YundongyuanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("运动员注册")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{name:'CaipanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("裁判员注册")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{name:'JiaolianList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("教练员注册")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我的会议培训",
      "label": "我报名的啦啦操的会议培训"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [(_vm.row.huiyi_count) ? _c('div', {
          staticClass: "badge"
        }, [_vm._v(_vm._s(_vm.row.huiyi_count))]) : _vm._e()]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a79ebea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/MyActivity.vue
// module id = 2183
// module chunks = 0